import { ApolloError } from '@apollo/client';

import * as Styled from './component-loading.style';

type Props = {
  hasData?: boolean;
  error?: ApolloError;
};

const ComponentLoading = ({ hasData, error }: Props) => {
  return error ? (
    <Styled.ComponentLoading></Styled.ComponentLoading>
  ) : !hasData ? (
    <Styled.ComponentLoading>
      <Styled.ComponentLoadingText>Loading...</Styled.ComponentLoadingText>
    </Styled.ComponentLoading>
  ) : null;
};

export default ComponentLoading;
